/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreviewEstimatedLaborCostDto } from '../../models/preview-estimated-labor-cost-dto';
import { PreviewEstimatedLaborCostRequest } from '../../models/preview-estimated-labor-cost-request';

export interface PreviewEstimatedLaborCost$Params {
      body: PreviewEstimatedLaborCostRequest
}

export function previewEstimatedLaborCost(http: HttpClient, rootUrl: string, params: PreviewEstimatedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PreviewEstimatedLaborCostDto>> {
  const rb = new RequestBuilder(rootUrl, previewEstimatedLaborCost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PreviewEstimatedLaborCostDto>;
    })
  );
}

previewEstimatedLaborCost.PATH = '/v0/estimatedLaborCost/preview';
